import React, { useState, useEffect, useContext, useCallback } from 'react'
import AuthContext from '../context/AuthContext'
import { Container, Box, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material'
import StudentDetailsComponent from '../components/StudentDetailsComponent'
import ErrorBoundary from '../components/ErrorBoundary'
import { useParams, Link } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { useTranslation } from 'react-i18next'

const StudentDetailsPage = () => {
    const { t } = useTranslation()
    const { authTokens, logoutUser, backendUrl } = useContext(AuthContext)
    const [student, setStudent] = useState(null)
    const [isLoading, setLoading] = useState(true)
    const params = useParams()

    useEffect(() => {
        if (params['student_id']) {
            getStudent()
        } else {
            setLoading(false)
        }
    }, [])

    const getStudent = useCallback(async () => {
        const response = await fetch(backendUrl + 'api/student/' + params['student_id'], {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            }
        })
        if (response.status === 200) {
            const data = await response.json()
            setStudent(data)
        } else if (response.status === 401) {
            logoutUser()
        }
        setLoading(false)
    }, [])

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <CircularProgress />
            </Box>
        )
    }

    const isEditing = Boolean(params['student_id'])

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 3 }}>
                <MuiLink component={Link} to="/students" underline="hover" color="inherit">
                    {t('students.title')}
                </MuiLink>
                <Typography color="text.primary">
                    {isEditing && student
                        ? `${student.firstname} ${student.lastname}`
                        : t('students.add_title')}
                </Typography>
            </Breadcrumbs>

            <ErrorBoundary>
                <StudentDetailsComponent student={student} />
            </ErrorBoundary>
        </Container>
    )
}

export default StudentDetailsPage
